/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../../../Container/Container";
import Grid from "@mui/material/Grid";
import ProvenExpertSealStandard from "../../../Provenexpert/ProvenExpertSealStandard";
import provenExpertGold from "../../../../assets/img/logo/proven_expert_empfehlung_2026.svg";
import partnersWide from "../../../../assets/img/logo/Bekannt_aus_desktop.png";
import trustSectionStyle from "./trustSectionStyle";
import QuotationCard from "../../../Cards/QuotationCard/QuotationCard";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Box, Theme } from "@mui/material";
import { CarouselSlides } from "../../../Carousel/CarouselSlides";
import { CarouselSlide } from "../../../Carousel/CarouselSlide";
import { useTheme } from "@mui/material/styles";
import { CarouselDots } from "../../../Carousel/CarouselDots";
import { CarouselProvider } from "../../../Carousel/CarouselProvider";

type TrustSectionProps = {
  showCoopPress?: boolean;
};

const TrustSection = ({ showCoopPress = true }: TrustSectionProps) => {
  const theme = useTheme();

  const allItemsDisplayed = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));

  return (
    <Container sx={trustSectionStyle.section}>
      <Box sx={trustSectionStyle.scrollToAnchor} id="kunden">
        {" "}
      </Box>
      <Typography variant={"h2"} sx={trustSectionStyle.heading}>
        Erfahrung aus zehntausenden Mandaten
      </Typography>
      <Grid
        container
        sx={{
          alignItems: "stretch",
          justifyContent: "center",
        }}
      >
        <Grid
          size={{
            xs: 6,
            md: 3,
          }}
        >
          <Box sx={trustSectionStyle.sealContainer}>
            <ProvenExpertSealStandard marginTop={"0px"} />
          </Box>
        </Grid>
        <Grid
          size={{
            xs: 6,
            md: 3,
          }}
        >
          <Box sx={trustSectionStyle.sealContainer}>
            <Box
              component={"img"}
              sx={{ ...trustSectionStyle.logo, ...trustSectionStyle.peGoldLogo }}
              src={provenExpertGold}
              alt={"Proven Expert Empfehlung"}
            />
          </Box>
        </Grid>
        <Grid size={12}>
          <Typography sx={{ paddingTop: "2rem", fontStyle: "italic" }} component={"blockquote"}>
            ”Ich hatte in der Vergangenheit Erfahrungen mit Anwälten, die extrem langsam waren und Monate gebraucht haben, um etwas zu erledigen. Bei euch ist
            das ganz anders: Ihr arbeitet unglaublich schnell und effizient! Als die Gegenseite auf ein Schreiben reagiert hat, habt ihr mich innerhalb von
            Minuten angerufen. Vielen Dank für diesen außergewöhnlichen Service – wirklich beeindruckend!”
          </Typography>
        </Grid>
        <Grid sx={trustSectionStyle.carouselContainer} size={12}>
          <CarouselProvider label={"Erfahrungen"} watchDrag={true}>
            <CarouselSlides>
              {[
                "Sehr freundlicher und kundenorientierter Service, sehr hilfsbereit und Fragen werden schnell und umfangreich behandelt. Absolut zu empfehlen!",
                "Ich hatte immer das Gefühl, persönlich angenommen und ernst genommen zu werden. Herzlichen Dank auch für die unproblematische Abwicklung!",
                "Ich habe mich mit meinem Anliegen zu jedem Zeitpunkt gut aufgehoben gefühlt. Der persönliche Kontakt zum Rechtsberater war stets sehr freundlich und unterstützend.",
                "Es waren nicht nur tolle Telefonate und herzliche Emails, sondern auch ein toller Online-Service mit sehr schnellem Erfolg. Wir sind einfach nur begeistert!",
              ].map((text, idx) => {
                return (
                  <CarouselSlide key={idx} sx={trustSectionStyle.slide}>
                    <QuotationCard text={text} />
                  </CarouselSlide>
                );
              })}
            </CarouselSlides>
            {!allItemsDisplayed && <CarouselDots />}
          </CarouselProvider>
        </Grid>
        {showCoopPress && (
          <>
            <Grid
              sx={trustSectionStyle.gridItem}
              size={{
                xs: 12,
                md: 8,
              }}
            >
              <Box sx={trustSectionStyle.logoContainer}>
                <Box component={"img"} src={partnersWide} alt={"Partner"} sx={trustSectionStyle.logo} />
              </Box>
            </Grid>
          </>
        )}
      </Grid>
    </Container>
  );
};

export default TrustSection;
